import { TransitionSpecs } from '@react-navigation/stack'

export const screenTransition = {
  transitionSpec: {
    open: TransitionSpecs.TransitionIOSSpec,
    close: TransitionSpecs.TransitionIOSSpec,
  },
  cardStyleInterpolator: ({ current, layouts }) => {
    return {
      cardStyle: {
        transform: [
          {
            translateX: current.progress.interpolate({
              inputRange: [0, 1],
              outputRange: [layouts.screen.width, 0],
            }),
          },
        ],
      },
    }
  },
}
export const isStatusOK = (data: any) =>
  (data?.httpCode === 200 || data?.httpCode?.toUpperCase() === 'SUCCESS') && data?.status?.toUpperCase() === 'SUCCESS'
export const isStatusSuccess = (data: any) => data?.status?.toUpperCase() === 'SUCCESS'

export const getNetworkResponseError = (data: any) => {
  let message = 'An unexpected error has occoured'
  let code = -1
  if (data?.error?.message) {
    message = data?.error?.message
    code = data?.error?.code
  } else if (data?.responseData?.message) {
    message = data?.responseData?.message
    code = data?.responseData?.code
  } else if (data?.responseMessage) {
    message = data?.responseMessage
    code = data?.responseCode
  } else if (data?.message) {
    message = data?.message
    code = data?.code
  }

  return { message, code }
}

export const shouldShowDateForSearch = (selectedFilter) =>
  [
    'Udf 1',
    'Udf 2',
    'Udf 3',
    'Udf 4',
    'Udf 5',
    'Terminal Id',
    'Offer Code',
    'Settlement RefNumber',
    'Account Number',
  ].includes(selectedFilter)

export const INFINITE_SCROLL_WINDOW = 7

export const INFINITE_SCROLL_WINDOW_INDEX = 2
